import { useEffect } from "react";
import { Select, SelectProps, } from "antd";
import { CategoryInfo } from "../api/models";
import Utils from "../util/util";
import useBaseCategories from "../swr/useBaseCategories";

export interface CategoryMultiSelectorProps extends SelectProps {
  value?:CategoryInfo[]
  onChange?: (users: CategoryInfo[]) => void;
  categoryLst?:CategoryInfo[]
}

const CategoryMultiSelector = (props: CategoryMultiSelectorProps) => {

  const categories = useBaseCategories().data;

  const { categoryLst:propCategoryLst, ...selectProps} = props;
  const categoryLst = propCategoryLst || categories;
  const value = props.value?.map( u => u.id );
  const options = categoryLst?.sort((a,b) => a.name.localeCompare(b.name)).map(c => ({label: Utils.stripSortingPrefix( c.name ), value: c.id}));

  return <Select 
    {...selectProps}
    onChange={(idLst) => {
      const idSet = new Set(idLst);
      const selected = categoryLst?.filter( u => idSet.has(u.id)) || [];
      props.onChange?.( selected );
    }}
    showSearch
    optionFilterProp="label" 
    mode={"multiple"}
    value={value}
    allowClear
    options={options}
  />

};

export default CategoryMultiSelector;
